import memoizer from 'fast-memoize'
import { createSelectorCreator, createSelector as reSelect } from 'reselect'

export const createMemoSelector = createSelectorCreator(memoizer)

export const createSelector = reSelect
